import React, { useState } from "react";
import styles from '../CustomDomainModal.module.css'
import { OptionButton } from '../CustomDomainModal'
import CTAButton from 'components/CTAButton/CTAButton'
import { CONN_PATH } from '../constants/strings'

export const ROOT_DOMAIN = 'root_domain';
export const SUB_DOMAIN = 'sub_domain';

const UploadConnPath = ({ formik, onNext, onPrevious, activeIndex, handleCheckEntri, setActiveStep }) => {
  const [loading, setLoading] = useState(false);
  const { values } = formik
  const isOwner = !!(values.dnsAddress.selected === 'yes')
  const isRootDomain = !!(values.path.selected === 'root_domain')
  const domain_value = values.dnsAddress.domain

  const getDomainAndSubdomain = (address) => {
    const splitAddress = address.split('.')
    if (splitAddress.length === 2) {
      return {
        domain: address,
        subdomain: 'myfile.' + address
      }
    } else {
      const domain = splitAddress.slice(1).join('.')
      return {
        domain: domain,
        subdomain: address
      }
    }
  }
  const handleNext = async () => {
    const payload = {
      domain: domain_value,
      owner: isOwner,
      replaceWWW: isRootDomain
    }
    setLoading(true)
    const response = await handleCheckEntri(payload, formik)
    if (response === 'manual') {
      formik.setFieldValue(`wizard.selected`, 'no')
      setActiveStep(4)
    } else if (response === 'automatic') {
      onNext()
    }
    setLoading(false)
  }


  return (
    <div className={styles.container}>
      {values.dnsAddress.selected === 'no' ? (
        <GoDaddyDomain formik={formik} onPrevious={onPrevious} onNext={onNext} />
      ) : (
        <>
          {' '}
          <div className={styles.subHeading}>
            <div className={styles.title}>{CONN_PATH.SUBHEADING}</div>
            <div className={styles.subTitle}>{CONN_PATH.DESCRIPTION}</div>
          </div>
          <div className={styles.optionCon}>
            <OptionButton
              actionDesc={`E.g ${getDomainAndSubdomain(values.dnsAddress.domain).domain}`}
              actionlabel="Whole Domain"
              active={values.path.selected === ROOT_DOMAIN}
              selectOption={() => {
                formik.setFieldValue(`path.selected`, values.path.selected === 'root_domain' ? null : 'root_domain')
              }}
            />
            <OptionButton
              actionDesc={`E.g. ${getDomainAndSubdomain(values.dnsAddress.domain).subdomain}`}
              actionlabel="Subdomain"
              selectOption={() => {
                formik.setFieldValue(`path.selected`, values.path.selected === 'sub_domain' ? null : 'sub_domain')
              }}
              active={values.path.selected === SUB_DOMAIN}
            />
          </div>
          {values.path.selected === 'root_domain' && (
            <div className={styles.warningBox}>
              <div className={styles.warningHeading}>
                <img src="/assets/icons/warning-yellow.svg" alt="warning" width="24" height="24" />
                <span>Warning</span>{' '}
              </div>
              <div className={styles.text}>
                <p>
                  Any existing website hosted on <span>{values.dnsAddress.domain}</span> will{' '}
                  <u><b>no longer be accessible</b></u> if you continue.
                </p>
                <p>If you want to host your files on an address like <b>myfile.{values.dnsAddress.domain}</b>, please select <b>Subdomain</b>.</p>
              </div>
            </div>
          )}
          <div className={styles.btnContainer}>
            <CTAButton
              label="Back"
              onClick={onPrevious}
              size="small"
              className={styles.backButton}
              showLeftArrow={true}
              showArrow={false}
              leftArrowClass={styles.backArrow}
              disabled={activeIndex === 0}
            />
            <CTAButton
              label="Next"
              onClick={handleNext}
              size="small"
              disabled={!values.path.selected}
              className={styles.forwardButton}
              loading={loading}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default UploadConnPath

const GoDaddyDomain = ({ formik, onNext, onPrevious }) => {
  return (
    <>
      <div className={styles.subHeading}>
        <div className={styles.title}>{CONN_PATH.PURCHASE_TITLE}</div>
        <div className={styles.subTitle}>{CONN_PATH.PURCHASE_DESC}</div>
        <div className={styles.goDaddyInput}>
          <input
            className={styles.input}
            placeholder="e.g. mywebsite.com"
            type="text"
            {...formik.getFieldProps(`dnsAddress.domain`)}
          />
          <CTAButton
            label="Search on Namecheap"
            onClick={() =>
              window.open(
                `https://www.namecheap.com/domains/registration/results/?domain=${formik.values.dnsAddress.domain}`
              )
            }
            size="small"
            disabled={!formik.values.dnsAddress.domain}
            className={styles.domainSearch}
          />
        </div>

        <div className={styles.subTitle}>{CONN_PATH.PURCHASE_DESC_2}</div>
      </div>
      <div className={styles.btnContainer}>
        <CTAButton
          label="Back"
          onClick={onPrevious}
          size="small"
          className={styles.backButton}
          showLeftArrow={true}
          showArrow={false}
          leftArrowClass={styles.backArrow}
        />
        <CTAButton label="I’ve purchased my domain" onClick={onNext} size="small" className={styles.forwardButton} />
      </div>
    </>
  )
}
